import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CloudinaryImage from 'common/image/CloudinaryImage';
import Link from 'common/router/Link';

export default class Promo extends PureComponent {
    static propTypes = {
        orientation: PropTypes.oneOf(['horizontal', 'vertical']),
        imageId: PropTypes.string.isRequired,
        imagePosition: PropTypes.oneOf(['badge', 'left', 'top', 'full']),
        title: PropTypes.string,
        content: PropTypes.string,
        buttonText: PropTypes.string,
        buttonLink: PropTypes.string
    };
    static defaultProps = {
        orientation: 'horizontal',
        imagePosition: 'badge'
    };

    constructor(props) {
        super(props);

        const {
            orientation,
            imagePosition
        } = props;

        switch (imagePosition) {
            case 'badge':
                this._imageWidth = 120;
                this._imageHeight = 120;

                break;

            case 'left':
                this._imageWidth = 150;
                this._imageHeight = 230;

                break;

            case 'top':
                this._imageWidth = 300;
                this._imageHeight = 150;

                break;

            case 'full':
                if (orientation === 'horizontal') {
                    this._imageWidth = 465;
                    this._imageHeight = 230;
                } else {
                    this._imageWidth = 300;
                    this._imageHeight = 400;
                }

                break;
        }
    }

    _renderImage() {
        return (
            <div className="Promo-image">
                <CloudinaryImage
                    width={this._imageWidth}
                    height={this._imageHeight}
                    cloudinaryImageId={this.props.imageId}
                />
            </div>
        );
    }

    render() {
        const {
            orientation,
            imagePosition,
            title,
            content,
            buttonText,
            buttonLink
        } = this.props;
        const classes = classNames(
            'Promo',
            `Promo-${orientation}`,
            `Promo-image-${imagePosition}`,
        );

        return (
            <div className={classes}>
                {(imagePosition === 'full' && buttonLink)
                    ? (
                        <Link to={buttonLink}>
                            {this._renderImage()}
                        </Link>
                    ) : (
                        this._renderImage()
                    )
                }
                {(imagePosition !== 'full' && (title || content || (buttonText && buttonLink))) &&
                    <div className="Promo-content">
                        {title &&
                            <h3 className="Promo-content-title">{title}</h3>
                        }
                        {content &&
                            <p>{content}</p>
                        }
                        {(buttonText && buttonLink) &&
                            <Link
                                className="Button Button-secondary"
                                to={buttonLink}
                            >
                                {buttonText}
                            </Link>
                        }
                    </div>
                }
            </div>
        );
    }
}
